import { render, staticRenderFns } from "./workComadd.vue?vue&type=template&id=4eaef19a&scoped=true&"
import script from "./workComadd.vue?vue&type=script&lang=js&"
export * from "./workComadd.vue?vue&type=script&lang=js&"
import style0 from "./workComadd.vue?vue&type=style&index=0&id=4eaef19a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaef19a",
  null
  
)

export default component.exports